var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.emailTemplate)?_c('span',[_vm._v("["+_vm._s(_vm.action.guestContactType)+"] "+_vm._s(_vm.actionStyling[_vm.action._type].description)+" '"+_vm._s(_vm.emailTemplate.name.substring(0,25))+"'")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }